// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 7.5C6 4.46243 8.46243 2 11.5 2C14.5376 2 17 4.46243 17 7.5C17 10.5376 14.5376 13 11.5 13C8.46243 13 6 10.5376 6 7.5ZM14.75 13.5H23.25V23.7945L19.0029 21.1781L14.75 23.7925V13.5ZM12.75 22H2V20C2 16.6863 4.68629 14 8 14H12.75V22Z"}}]};

const UserMarkedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-marked-filled',
    ref,
    icon: element,
  },
));

UserMarkedFilledIcon.displayName = 'UserMarkedFilledIcon';

export default UserMarkedFilledIcon;
